import { useFilterEmployeeIncentiveContext } from "./filter-employee-incentive.context";

export function FilterEmployeeIncentive() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeeIncentiveContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}